import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardFooter, CardHeader, Col, Row, Table,
} from 'reactstrap';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';
import { deleteContinent, fetchContinent } from '../../actions/continents';
import Can from '../../components/can';
import PinModal from '../../components/pin';

class Continent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.requestDelete = this.requestDelete.bind(this);
    this.failedDelete = this.failedDelete.bind(this);
  }

  componentWillMount() {
    const { getContinent } = this.props;
    getContinent();
  }

  requestDelete(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedDelete() {
    this.setState({
      submitted: false,
    });
  }

  handleDelete() {
    const { deleteContinentAction, goToList } = this.props;
    deleteContinentAction().then(() => goToList());
  }

  render() {
    const { submitted } = this.state;
    const { continent } = this.props;
    if (!continent || Object.keys(continent).length === 0) {
      return (null);
    }
    return (
      <div className="animated fadeIn">
        {
          submitted
          && <PinModal successSubmit={this.handleDelete} failedSubmit={this.failedDelete} />
        }
        <Row>
          <Col lg={6}>
            <Card>
              <CardHeader>
                <strong>
                  {'Continent ID: '}
                  {continent.id}
                </strong>
                <div className="card-header-actions">
                  <Can I="update" a="Continent">
                    <Button href={`/#/continents/${continent.id}/edit`} color="link" className="card-header-action btn-setting">
                      <i className="icon-note" />
                    </Button>
                  </Can>
                  <Can I="delete" a="Continent">
                    <Button color="link" className="card-header-action btn-setting" onClick={e => this.requestDelete(e)}>
                      <i className="icon-trash" />
                    </Button>
                  </Can>
                </div>
              </CardHeader>
              <CardBody>
                <Table responsive striped hover>
                  <tbody>
                    <tr key="id">
                      <td>Continent ID:</td>
                      <td><strong>{continent.id}</strong></td>
                    </tr>
                    <tr key="name">
                      <td>Continent Name:</td>
                      <td><strong>{continent.name}</strong></td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                <Button href={`/#/continents/${continent.id}/edit`} color="secondary" size="sm">Edit</Button>
                {' '}
                <Button color="danger" onClick={e => this.requestDelete(e)} size="sm">Delete</Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

Continent.propTypes = {
  deleteContinentAction: PropTypes.func.isRequired,
  getContinent: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
  continent: PropTypes.shape({}),
};

Continent.defaultProps = {
  continent: {},
};

const mapStateToProps = ({ continents }) => ({
  continent: continents.item,
});

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  deleteContinentAction: () => deleteContinent(ownProps.match.params.id),
  getContinent: () => fetchContinent(ownProps.match.params.id),
  goToList: () => goBack(),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Continent);
